module.exports = __webpack_public_path__ + "static/rc-8-3e7a1777ab077c3305f1f1f60b2594de.jpg";